import React from 'react';
import { fade, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import MoreIcon from '@material-ui/icons/MoreVert';
import logoImg from '../../img/logo.svg';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import {changeSearchElement,changeAdminOn} from '../actions/index'
import SearchBar from './SearchBar'
import {connect} from 'react-redux'
import LoginModal from './LoginModal'
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

function PrimarySearchAppBar(props) {

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [logado,setLogado] = React.useState(false);
  const [user,setUser] = React.useState('');
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const {cart} = props;

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = event => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  const handleLogin = (user) =>{
    setUser(user)
    setLogado(true)
    if(user==='admin'){
      props.changeAdminOn(true)
    }
  };
  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Carrinho</MenuItem>
      <MenuItem onClick={handleMenuClose}>Minha Conta</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <>
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      
      <MenuItem>
        <Link to="/cart" style={{color:'black',textDecoration:'none'}}>
            <IconButton aria-label="show 4 new mails" color="inherit">
              <Badge badgeContent={cart.length} color="secondary">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>
          </Link>
        <p>Carrinho</p>
      </MenuItem>
      {logado ? (
              <div className="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit">
                <p>Olá, {user}</p>
              </div>
            ):(
              <MenuItem>
                <LoginModal handleLogin={handleLogin}></LoginModal>
                <p>Login</p>
              </MenuItem>
            )}
    </Menu>
    </>
  );
  
  return (
    <div className={classes.grow}>
      <AppBar className="app-bar" position="static">
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="open drawer"
          >
            <Link to ='/'><img className="logo-image d-inline-block align-top" src={logoImg} alt="logoImage"/></Link>
          </IconButton>
          <Link to='/' style={{color:'white',textDecoration:'none'}}><Typography className={`${classes.title} company-name`} variant="h6" noWrap>
            Tranqueiria
          </Typography></Link>
          <div className="search-section">
             <SearchBar />       
          </div>

          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <IconButton aria-label="show 4 new mails" color="inherit">
              <Badge badgeContent={cart.length} color="secondary">
              <Link to="/cart" style={{color:'white'}}><ShoppingCartIcon /></Link>
              </Badge>
            </IconButton>
            {logado ? (
              <div className="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit">
                Olá, {user}
              </div>
            ):(
              <LoginModal handleLogin={handleLogin}></LoginModal>
            )}
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
              className="btn-menu-mobile"
            >
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
  
}

const mapStateToProps = state => ({
    cart: state.cart  
});

const mapDispatchToProps = (dispatch) =>({
  changeSearchElement: (searchElement) => dispatch(changeSearchElement(searchElement)),
  changeAdminOn: (status) => dispatch(changeAdminOn(status))
});

export default connect(mapStateToProps,mapDispatchToProps)(PrimarySearchAppBar);


